import {TypeConstant} from "./TypeConstant";

const initStat = {
    ar_name : '',
    ar_email:'',
    ar_jobTitle : '',
    ar_department: '',
    ar_mobile:'',
    ar_website:'',
    flag:false
}


const ArabicReducer = (state = initStat , action) => {

    switch (action.type) {
        case TypeConstant.Ar_Name: return {...state, ar_name : action.payload }
        case TypeConstant.Ar_Email: return {...state, ar_email:action.payload}
        case TypeConstant.Ar_JobTitle: return {...state, ar_jobTitle:action.payload}
        case TypeConstant.Ar_Department: return {...state, ar_department :action.payload}
        case TypeConstant.Ar_Mobile: return {...state, ar_mobile:action.payload}
        case TypeConstant.Ar_Website: return {...state, ar_website:action.payload}
        case 'FLAG': return {...state, flag:action.payload}
        default: return state;
    }

}


export default ArabicReducer
